import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import { AbilityContext, Can } from '../../_contexts/AbilitiesContext'

import Settings from '../../_layouts/Settings/';
import WelcomePage from './WelcomePage';
import TodaysForms from './TodaysForms';
import TodaysEvents from './TodaysEvents';
import YourMessages from './YourMessages';
import AuthorizedRoute from '../../_helpers/authorized.route';
import TodaysTelehealths from './TodaysTelehealths';

import { useSelector } from 'react-redux';
import { Link, Switch } from 'react-router-dom';

export default function Dashboard({ history }) {
  const abilities = useContext(AbilityContext)

  const clientDetails = useSelector(state => state.client);
  const currentUser = useSelector(state => state.user.currentUser);

  const [showWelcome, setShowWelcome] = useState(history.location.state ? history.location.state.welcome : false)

  useEffect(() => {
    setShowWelcome(showWelcome)
  }, [showWelcome])
  
  useEffect(() => {
    if (history.location.pathname === '/dashboard' && !showWelcome) {
      const savedLocation = JSON.parse(localStorage.getItem('dashboardLocation'));

      if (savedLocation) {
        history.push(savedLocation)
      } else if (abilities.can('view', 'messages')) {
        history.push('/dashboard/messages')
      } else if (abilities.can('view', 'form')) { 
        history.push('/dashboard/forms')
      } else if (abilities.can('view', 'telehealth')) {
        history.push('/dashboard/telehealth')
      } else if (abilities.can('view', 'events')) { 
        history.push('/dashboard/events')
      } else {
        history.push('/dashboard')
      }
    }
  }, [abilities, history, showWelcome])

  useEffect(() => {
    if (!showWelcome) {
      localStorage.setItem('dashboardLocation', JSON.stringify(history.location.pathname));
    }
  }, [history, history.location.pathname, showWelcome])

  return (
    showWelcome ? <WelcomePage clientDetails={ clientDetails } currentUser={currentUser}/>
    :
    <div className="container">
      <div className="row mt-4">
        <div className="col pl-0">
          <div className="d-flex align-items-center mt-2">
            <h1 className="h2 mr-2"><i className="fas fa-chart-line"></i> Today's Dashboard</h1>
            <h1 className="h5 text-muted my-auto">{moment().format('MMMM D, YYYY')}</h1>
          </div>
        </div>
      </div>

      <div className="row">
        <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block nav flex-column nav-pills" style={{ top: '1.5em', padding: 0, backgroundColor: 'unset' }}>
          <ul className="nav flex-column">

            <Can I="view" a="form">
              <li className="nav-item mb-2">
                <Link to="/dashboard/forms" className={`nav-link ${history.location.pathname.indexOf('/dashboard/forms') === 0 ? 'active' : 'text-dark'}`}>
                  <i className="far fa-file-alt fa-fw" aria-hidden="true"></i>&nbsp;Forms Due
                </Link>
              </li>
            </Can>

            <Can I="view" a="telehealth">
              <li className="nav-item mb-2">
                <Link to="/dashboard/telehealths" className={`nav-link ${history.location.pathname.indexOf('/dashboard/telehealths') === 0 ? 'active' : 'text-dark'}`}>
                  <i className="fas fa-laptop-medical fa-fw" aria-hidden="true"></i>&nbsp;Telehealth
                </Link>
              </li>
            </Can>

            <Can I="view" a="events">
              <li className="nav-item mb-2">
                <Link to="/dashboard/events" className={`nav-link ${history.location.pathname.indexOf('/dashboard/events') === 0 ? 'active' : 'text-dark'}`}>
                  <i className="far fa-calendar-alt fa-fw" aria-hidden="true"></i>&nbsp;Events
                </Link>
              </li>
            </Can>

            <Can I="view" a="messages">
              <li className="nav-item mb-2">
                <Link to="/dashboard/messages" className={`nav-link ${history.location.pathname.indexOf('/dashboard/messages') === 0 ? 'active' : 'text-dark'}`}>
                  <i className="far fa-comment-dots fa-fw" aria-hidden="true"></i>&nbsp;Your Messages
                </Link>
              </li>
            </Can>

          </ul>
        </nav>

        <main role="main" className="col-lg-10 col-md-9 ml-sm-auto px-md-3">
          <Switch>
            <AuthorizedRoute path="/dashboard/forms" layout={Settings} component={TodaysForms} />

            <AuthorizedRoute path="/dashboard/events" layout={Settings} component={TodaysEvents} />

            <AuthorizedRoute path="/dashboard/messages" layout={Settings} component={YourMessages} />

            <AuthorizedRoute path="/dashboard/telehealths" layout={Settings} component={TodaysTelehealths} />
          </Switch>
        </main>
      </div>
    </div>
  )
}
